import React from 'react';
import LayoutBanner from '../components/page-layouts/layoutBanner.js';
import Login from '../containers/login.js';

const TemporalAccess = () => (
  <div>
    <LayoutBanner />
    <Login />
  </div>
);

export default TemporalAccess;



// WEBPACK FOOTER //
// ./src/scene/temporalAccess.js